import { render, staticRenderFns } from "./projectcategorydetails.vue?vue&type=template&id=15d7a30e&scoped=true&"
import script from "./projectcategorydetails.vue?vue&type=script&lang=js&"
export * from "./projectcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./projectcategorydetails.vue?vue&type=style&index=0&id=15d7a30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d7a30e",
  null
  
)

export default component.exports